import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Owner = /*#__PURE__*/function (Owner) {
  Owner[Owner["OWNER_NOT_SPECIFIED"] = 0] = "OWNER_NOT_SPECIFIED";
  Owner[Owner["OWNER_SOCIAL_MARKETING"] = 1] = "OWNER_SOCIAL_MARKETING";
  Owner[Owner["OWNER_CUSTOMER_VOICE"] = 2] = "OWNER_CUSTOMER_VOICE";
  Owner[Owner["OWNER_CORE_SERVICES"] = 3] = "OWNER_CORE_SERVICES";
  Owner[Owner["OWNER_EMAIL_VERIFICATION"] = 4] = "OWNER_EMAIL_VERIFICATION";
  Owner[Owner["OWNER_SMB_REFERRAL"] = 5] = "OWNER_SMB_REFERRAL";
  Owner[Owner["OWNER_UNTRACKED"] = 6] = "OWNER_UNTRACKED";
  Owner[Owner["OWNER_INBOX_BUSINESS"] = 7] = "OWNER_INBOX_BUSINESS";
  Owner[Owner["OWNER_REPUTATION_MANAGEMENT"] = 8] = "OWNER_REPUTATION_MANAGEMENT";
  return Owner;
}(Owner || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 0] = "SORT_DIRECTION_DESCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  return SortDirection;
}(SortDirection || {});
var SortField = /*#__PURE__*/function (SortField) {
  SortField[SortField["SORT_FIELD_CREATED"] = 0] = "SORT_FIELD_CREATED";
  SortField[SortField["SORT_FIELD_LONGURL"] = 1] = "SORT_FIELD_LONGURL";
  SortField[SortField["SORT_FIELD_FACEBOOK"] = 2] = "SORT_FIELD_FACEBOOK";
  SortField[SortField["SORT_FIELD_TWITTER"] = 3] = "SORT_FIELD_TWITTER";
  SortField[SortField["SORT_FIELD_LINKEDIN"] = 4] = "SORT_FIELD_LINKEDIN";
  SortField[SortField["SORT_FIELD_GOOGLE"] = 5] = "SORT_FIELD_GOOGLE";
  SortField[SortField["SORT_FIELD_OTHER"] = 6] = "SORT_FIELD_OTHER";
  SortField[SortField["SORT_FIELD_TOTAL"] = 7] = "SORT_FIELD_TOTAL";
  return SortField;
}(SortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Link {
  static fromProto(proto) {
    let m = new Link();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.owner) {
      m.owner = enumStringToValue$2(Owner, proto.owner);
    }
    if (proto.hidden) {
      m.hidden = new Date(proto.hidden);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.shortCode !== 'undefined') {
      toReturn['shortCode'] = this.shortCode;
    }
    if (typeof this.longUrl !== 'undefined') {
      toReturn['longUrl'] = this.longUrl;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.hidden !== 'undefined' && this.hidden !== null) {
      toReturn['hidden'] = 'toApiJson' in this.hidden ? this.hidden.toApiJson() : this.hidden;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateLinkRequest {
  static fromProto(proto) {
    let m = new CreateLinkRequest();
    m = Object.assign(m, proto);
    if (proto.owner) {
      m.owner = enumStringToValue$1(Owner, proto.owner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.linkUrl !== 'undefined') {
      toReturn['linkUrl'] = this.linkUrl;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    if (typeof this.sensitiveUrl !== 'undefined') {
      toReturn['sensitiveUrl'] = this.sensitiveUrl;
    }
    return toReturn;
  }
}
class CreateLinkResponse {
  static fromProto(proto) {
    let m = new CreateLinkResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.shortCode !== 'undefined') {
      toReturn['shortCode'] = this.shortCode;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class GetLinkRequest {
  static fromProto(proto) {
    let m = new GetLinkRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.shortCode !== 'undefined') {
      toReturn['shortCode'] = this.shortCode;
    }
    return toReturn;
  }
}
class GetLinkResponse {
  static fromProto(proto) {
    let m = new GetLinkResponse();
    m = Object.assign(m, proto);
    if (proto.link) {
      m.link = Link.fromProto(proto.link);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.link !== 'undefined' && this.link !== null) {
      toReturn['link'] = 'toApiJson' in this.link ? this.link.toApiJson() : this.link;
    }
    return toReturn;
  }
}
class GetMultiLinkMetricsRequest {
  static fromProto(proto) {
    let m = new GetMultiLinkMetricsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.shortCode !== 'undefined') {
      toReturn['shortCode'] = this.shortCode;
    }
    return toReturn;
  }
}
class GetMultiLinkMetricsResponse {
  static fromProto(proto) {
    let m = new GetMultiLinkMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.linkMetrics) {
      m.linkMetrics = proto.linkMetrics.map(LinkMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.linkMetrics !== 'undefined' && this.linkMetrics !== null) {
      toReturn['linkMetrics'] = 'toApiJson' in this.linkMetrics ? this.linkMetrics.toApiJson() : this.linkMetrics;
    }
    return toReturn;
  }
}
class LinkMetrics {
  static fromProto(proto) {
    let m = new LinkMetrics();
    m = Object.assign(m, proto);
    if (proto.totalHits) {
      m.totalHits = parseInt(proto.totalHits, 10);
    }
    if (proto.referers) {
      m.referers = Object.keys(proto.referers).reduce((obj, k) => {
        obj[k] = parseInt(proto.referers[k], 10);
        return obj;
      }, {});
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalHits !== 'undefined') {
      toReturn['totalHits'] = this.totalHits;
    }
    if (typeof this.referers !== 'undefined' && this.referers !== null) {
      toReturn['referers'] = 'toApiJson' in this.referers ? this.referers.toApiJson() : this.referers;
    }
    if (typeof this.shortCode !== 'undefined') {
      toReturn['shortCode'] = this.shortCode;
    }
    if (typeof this.longUrl !== 'undefined') {
      toReturn['longUrl'] = this.longUrl;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class ListAllLinkMetricsRequest {
  static fromProto(proto) {
    let m = new ListAllLinkMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.sortField) {
      m.sortField = enumStringToValue$1(SortField, proto.sortField);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$1(SortDirection, proto.sortDirection);
    }
    if (proto.owner) {
      m.owner = enumStringToValue$1(Owner, proto.owner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.filterTerm !== 'undefined') {
      toReturn['filterTerm'] = this.filterTerm;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class ListAllLinkMetricsResponse {
  static fromProto(proto) {
    let m = new ListAllLinkMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.linkMetrics) {
      m.linkMetrics = proto.linkMetrics.map(LinkMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.linkMetrics !== 'undefined' && this.linkMetrics !== null) {
      toReturn['linkMetrics'] = 'toApiJson' in this.linkMetrics ? this.linkMetrics.toApiJson() : this.linkMetrics;
    }
    return toReturn;
  }
}
class ListLinksRequest {
  static fromProto(proto) {
    let m = new ListLinksRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = PagedRequestOptions.fromProto(proto.options);
    }
    if (proto.owner) {
      m.owner = enumStringToValue$1(Owner, proto.owner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class ListLinksResponse {
  static fromProto(proto) {
    let m = new ListLinksResponse();
    m = Object.assign(m, proto);
    if (proto.link) {
      m.link = proto.link.map(Link.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.link !== 'undefined' && this.link !== null) {
      toReturn['link'] = 'toApiJson' in this.link ? this.link.toApiJson() : this.link;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class LinkMetricsReferersEntry {
  static fromProto(proto) {
    let m = new LinkMetricsReferersEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class SetLinkHideStatusesRequest {
  static fromProto(proto) {
    let m = new SetLinkHideStatusesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.shortCodes !== 'undefined') {
      toReturn['shortCodes'] = this.shortCodes;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class HeaderValues {
  static fromProto(proto) {
    let m = new HeaderValues();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class VisitHeadersEntry {
  static fromProto(proto) {
    let m = new VisitHeadersEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = HeaderValues.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Visit {
  static fromProto(proto) {
    let m = new Visit();
    m = Object.assign(m, proto);
    if (proto.headers) {
      m.headers = Object.keys(proto.headers).reduce((obj, k) => {
        obj[k] = HeaderValues.fromProto(proto.headers[k]);
        return obj;
      }, {});
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.link) {
      m.link = Link.fromProto(proto.link);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.sessionId !== 'undefined') {
      toReturn['sessionId'] = this.sessionId;
    }
    if (typeof this.link !== 'undefined' && this.link !== null) {
      toReturn['link'] = 'toApiJson' in this.link ? this.link.toApiJson() : this.link;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'url-shortener-api.vendasta-local.com',
  'test': '',
  'demo': 'url-shortener-api-demo.apigateway.co',
  'prod': 'url-shortener-api-prod.apigateway.co',
  'production': 'url-shortener-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let UrlShortenerApiService = /*#__PURE__*/(() => {
  class UrlShortenerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createLink(r) {
      const request = r.toApiJson ? r : new CreateLinkRequest(r);
      return this.http.post(this._host + "/url_shortener.v1.UrlShortener/CreateLink", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateLinkResponse.fromProto(resp)));
    }
    getLink(r) {
      const request = r.toApiJson ? r : new GetLinkRequest(r);
      return this.http.post(this._host + "/url_shortener.v1.UrlShortener/GetLink", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLinkResponse.fromProto(resp)));
    }
    listLinks(r) {
      const request = r.toApiJson ? r : new ListLinksRequest(r);
      return this.http.post(this._host + "/url_shortener.v1.UrlShortener/ListLinks", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLinksResponse.fromProto(resp)));
    }
    getMultiLinkMetrics(r) {
      const request = r.toApiJson ? r : new GetMultiLinkMetricsRequest(r);
      return this.http.post(this._host + "/url_shortener.v1.UrlShortener/GetMultiLinkMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiLinkMetricsResponse.fromProto(resp)));
    }
    listAllLinkMetrics(r) {
      const request = r.toApiJson ? r : new ListAllLinkMetricsRequest(r);
      return this.http.post(this._host + "/url_shortener.v1.UrlShortener/ListAllLinkMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllLinkMetricsResponse.fromProto(resp)));
    }
    setLinkHideStatuses(r) {
      const request = r.toApiJson ? r : new SetLinkHideStatusesRequest(r);
      return this.http.post(this._host + "/url_shortener.v1.UrlShortener/SetLinkHideStatuses", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  UrlShortenerApiService.ɵfac = function UrlShortenerApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UrlShortenerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  UrlShortenerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UrlShortenerApiService,
    factory: UrlShortenerApiService.ɵfac,
    providedIn: 'root'
  });
  return UrlShortenerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UrlShortenerService = /*#__PURE__*/(() => {
  class UrlShortenerService {
    constructor(api) {
      this.api = api;
    }
    getLink(shortCode) {
      const req = new GetLinkRequest({
        shortCode: shortCode
      });
      return this.api.getLink(req).pipe(map(resp => resp.link));
    }
    createLink(businessId, linkUrl, owner, description, hidden) {
      const req = new CreateLinkRequest({
        businessId: businessId,
        linkUrl: linkUrl,
        owner: owner,
        description: description,
        hidden: hidden
      });
      return this.api.createLink(req);
    }
    listLinks(businessId, cursor, pageSize, owner) {
      const req = new ListLinksRequest({
        businessId: businessId,
        owner: owner,
        options: new PagedRequestOptions({
          cursor: cursor,
          pageSize: pageSize
        })
      });
      return this.api.listLinks(req).pipe(map(resp => new PagedResponse(resp.link, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore)));
    }
    listLinkMetrics(businessId, sortField, filterTerm, sortDirection, owner) {
      const body = {
        businessId: businessId,
        sortField: sortField,
        filterTerm: filterTerm,
        sortDirection: sortDirection,
        owner: owner
      };
      const req = new ListAllLinkMetricsRequest(body);
      return this.api.listAllLinkMetrics(req).pipe(map(resp => resp.linkMetrics));
    }
    setLinkHideStatuses(businessId, shortCodes, hidden) {
      const req = new SetLinkHideStatusesRequest({
        businessId: businessId,
        shortCodes: shortCodes,
        hidden: hidden
      });
      return this.api.setLinkHideStatuses(req).pipe(map(res => res.status === 200));
    }
  }
  UrlShortenerService.ɵfac = function UrlShortenerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UrlShortenerService)(i0.ɵɵinject(UrlShortenerApiService));
  };
  UrlShortenerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UrlShortenerService,
    factory: UrlShortenerService.ɵfac,
    providedIn: 'root'
  });
  return UrlShortenerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}

/**
 * Generated bundle index. Do not edit.
 */

export { CreateLinkResponse, Link, LinkMetrics, Owner, PagedResponse, SortDirection, SortField, UrlShortenerService };
